<section class="container1">
  <div class="text-center">
    <form class="example-form select1">
      <input class="projectInput" type="text" #box (keyup)="getValue(box.value)"
        placeholder="select an existing project or create a new one" [matAutocomplete]="auto" name="project"
        [formControl]="formGroup.controls['name']" autocomplete="off">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let project of filteredList" [value]="project.name" (click)="selectProject(project)">
          <div class="project-name-container">
            <span class="project-name">{{project?.name}}</span>
          </div>
          <span *ngIf="project?.mapped === 'jira'" class="jira-label">Jira Project</span>
          <span *ngIf="project?.mapped === 'agileStudio'" class="jira-label">Agile Project</span>
        </mat-option>
        <mat-option *ngIf="showCreateOption" (click)="createProject()">
          Create new project with "{{displayValue}}"
        </mat-option>
      </mat-autocomplete>
    </form>
    <div #multiselect class="map ">
      <button type="submit" class="map__button map__button--primary" (click)="navigateToApp(selectedProject)">
        <span class="material-icons map__icon">folder_open</span>
        <span class="map__text">Open Project</span>
      </button>
      <button type="button" class="map__button map__button--menu" (click)="expandtoggle()"
        [disabled]="!selectedProject">
        <span class="material-icons map__icon">expand_more</span>
      </button>
      <div class="map__list" *ngIf="expand">
        <button type="submit" class="map__button map__button--secondary othrebutton" (click)="modifyProject()">
          <span class="material-icons map__icon ">edit</span>
          <span class="map__text">Modify</span>
        </button>
        <button *ngIf="mappedProject" type="submit" class="map__button map__button--secondary othrebutton"
          (click)="updateSyncProject()">
          <span class="material-icons map__icon ">update</span>
          <span class="map__text">Sync</span>
        </button>
        <button type="submit" class="map__button map__button--secondary othrebutton" (click)="deleteProject()">
          <span class="material-icons map__icon ">delete</span>
          <span class="map__text">Delete</span>
        </button>
      </div>
    </div>
  </div>
</section>